// Sentry no-op shim for web — Sentry RN uses native crash reporters not available in browsers
export const init = () => {};
export const setUser = () => {};
export const captureException = () => '';
export const captureMessage = () => '';
export const addBreadcrumb = () => {};
export const configureScope = () => {};
export const withScope = (cb) => cb({ setExtra: () => {}, setTag: () => {}, setLevel: () => {}, setUser: () => {} });
export const setTag = () => {};
export const setExtra = () => {};
export const setContext = () => {};
export const startTransaction = () => ({ finish: () => {}, setStatus: () => {}, setTag: () => {} });
export const wrap = (component) => component;
export const ReactNativeTracing = class {};
export const BrowserTracing = class {};
export const Severity = {
  Fatal: 'fatal',
  Error: 'error',
  Warning: 'warning',
  Info: 'info',
  Debug: 'debug',
  Critical: 'critical',
  Log: 'log',
};
export const SeverityLevel = Severity;

export default {
  init,
  setUser,
  captureException,
  captureMessage,
  addBreadcrumb,
  withScope,
  setTag,
  setExtra,
  setContext,
  wrap,
  Severity,
  SeverityLevel,
};
